import { AppFilterType } from "@/components/filter/filter.types.ts";
import { useTeamsByIds } from "@/queries/use-teams.query.ts";
import { ApiPeopleAnalyticsEmployeeFilter } from "@/types/reporting/people-analytics.types.ts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface PeopleFilterField {
  type: AppFilterType;
  name: keyof ApiPeopleAnalyticsEmployeeFilter;
  labelKey: string;
}

export const PEOPLE_FILTER_FIELDS: PeopleFilterField[] = [
  { type: AppFilterType.employeeTeam, name: "team_ids", labelKey: "core:team" },
];

export interface FilterCardData {
  type: AppFilterType;
  name: keyof ApiPeopleAnalyticsEmployeeFilter;
  label: string;
  value: string;
}

const EMPTY_IDS: number[] = [];

export function useFilterCards(filter: ApiPeopleAnalyticsEmployeeFilter): FilterCardData[] {
  const { t } = useTranslation();

  const teamIds = filter.team_ids ?? EMPTY_IDS;
  const { data: teams } = useTeamsByIds(teamIds, teamIds.length > 0);

  return useMemo(() => {
    if (!teamIds.length) return [];
    const names = teamIds
      .map((id) => teams?.find((team) => team.id === id)?.title)
      .filter((title): title is string => Boolean(title));
    return [
      {
        type: AppFilterType.employeeTeam,
        name: "team_ids",
        label: t("core:team"),
        value: names.length ? names.join(", ") : String(teamIds.length),
      },
    ];
  }, [t, teamIds, teams]);
}
